import styled from "@emotion/styled";
import InputBlurChange from "metabase/components/InputBlurChange";
import { color } from "metabase/lib/colors";
export const ColumnItemInput = styled(InputBlurChange)`
  border-color: ${color("border")};

  background-color: ${(props) => color(props.variant === "primary" ? "white" : "bg-light")};
`;
